import { Component, OnInit } from '@angular/core';
import { Login } from '../models/login.model';
import { NgForm, FormGroup, FormControl } from '@angular/forms';
import { UserService } from "../services/user.service";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MenuService } from '../services/menu.service';
import {environment} from '../../environments/environment'
import { TranslateService } from '@ngx-translate/core';
import { EnviromentService } from '../services/enviroment.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  private SelectedAppKey = 'SELECTEDAPP';

  loginForm: FormGroup;
  externalLogin:boolean = environment.externalLogin;

  constructor(
    private userService: UserService, 
    private notificationsService: ToastrService,
    private menuService:MenuService,
    private router: Router,
    private translateService: TranslateService,
    private enviromentService: EnviromentService
  ) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl(),
      pasword: new FormControl()
    });
  }
  OnSubmit() {
    
    let email:string = this.loginForm.get("email").value;
    let password:string = this.loginForm.get("pasword").value;

    this.userService.login(email,password).subscribe(
      (data: any) => {
      // this.notificationsService.success("User authenticated");
      this.menuService.GetApps().subscribe(()=>{
        const selectedApp = this.enviromentService.getLocal(this.SelectedAppKey);        
        const query = {};
        if (selectedApp) {
          query['module'] = selectedApp;
        }
        this.router.navigate(["home"], { queryParams: query });
      });
      },
      (error) => {
        this.translateService.get(['user.login','errors.login']).subscribe(res=>{
          this.notificationsService.error(res['errors.login'],res['user.login']);
        })
      }
    );
  }
}
